import React, { useState } from "react";

import PretendardText from "../../../atoms/text/pretendardText";
import MainInput from "../../../atoms/input/mainInput";

import Popup from "../../../molecules/popup";

import PopupOverLay from "../../PopupOverlay";
import TextArea from "../../../atoms/input/textarea";
import MemberApi from "../../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import { errorHandler } from "../../../../util/errorHandler";

const AlarmSendPopup = ({
  setPopupOpen,
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
}) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [url, setUrl] = useState("");

  const alarmSendFunc = async () => {
    try {
      let memberIdsTemp = userCheckedIdList.map((item) => item.id);

      const data = {
        memberIds: memberIdsTemp,
        title: title,
        content: content,
        url: url,
      };

      await MemberApi.alarmSend(data);

      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
      setPopupOpen(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <PopupOverLay
      isOpen={true}
      onClick={() => {
        setPopupOpen(false);
      }}
    >
      <Popup
        style={{
          width: 632,
        }}
        headerTitle="알림 보내기"
        footerBtnText="보내기"
        onClick={() => {
          setPopupOpen(false);
        }}
        footerBtnHandler={() => {
          alarmSendFunc();
        }}
      >
        <div
          // className="custom-scrollbar"
          style={{
            width: "100%",
            // height: 350,
            // overflowY: "auto",
            padding: "0px 30px",
            margin: "24px 0px 20px 0px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          {/* 발송대상 */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              발송대상
            </PretendardText>
            <PretendardText
              style={{
                fontSize: "15px",
                fontWeight: "400",
                lineHeight: "21.25px",
                color: "#aaa",
              }}
            >
              {userCheckedIdList.map((item, index) => {
                if (userCheckedIdList.length === index + 1) {
                  return item.email;
                } else {
                  return `${item.email}, `;
                }
              })}
            </PretendardText>
          </div>

          {/* 알림 제목 */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              알림 제목
            </PretendardText>
            <MainInput
              type={"text"}
              placeholder={"내용을 입력해 주세요."}
              style={{ width: "100%" }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div>

          {/* 알림 내용 */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              알림 내용
            </PretendardText>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <TextArea
                type={"text"}
                placeholder={"내용을 입력해주세요"}
                value={content}
                onChange={(e) => {
                  setContent(e.target.value);
                }}
                maxLength={50}
                style={{
                  width: "572px",
                  minHeight: "107px",
                }}
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  {content.length}/50
                </PretendardText>
              </div>
            </div>
          </div>

          {/* URL 입력(선택사항) */}
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              URL 입력(선택사항)
            </PretendardText>
            <MainInput
              type={"text"}
              placeholder={"내용을 입력해 주세요."}
              style={{ width: "100%" }}
              value={url}
              onChange={(e) => {
                setUrl(e.target.value);
              }}
            />
            <PretendardText
              style={{
                fontSize: "13px",
                fontWeight: "500",
                lineHeight: "18.75px",
                color: "rgba(181, 181, 181, 0.5)",
              }}
            >
              알림창을 클릭 시 이동할 페이지
            </PretendardText>
          </div>
        </div>
      </Popup>
    </PopupOverLay>
  );
};

export default AlarmSendPopup;
